"use client";

import { useState } from "react";

interface CompetitionTab {
  label: React.ReactNode;
  count: number;
  iconSrc?: string;
}

interface CompetitionTabsProps {
  tabs: CompetitionTab[];
  onTabChange?: (_index: number) => void;
}

export default function CompetitionTabs({ tabs, onTabChange }: CompetitionTabsProps) {
  const [activeTab, setActiveTab] = useState(0);

  function handleTabClick(index: number) {
    setActiveTab(index);
    onTabChange?.(index);
  }

  return (
    <div className="flex items-end lg:items-center justify-center w-full pt-3 lg:pt-5 px-2.5 gap-3 lg:gap-6 bg-white shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]">
      {tabs.map((tab, index) => {
        const isActive = activeTab === index;
        return (
          <button
            key={`${index}_tab`}
            onClick={() => handleTabClick(index)}
            aria-selected={isActive}
            role="tab"
            className={[
              "flex flex-1 lg:flex-initial items-center justify-center pb-2.5 px-2 gap-2 cursor-pointer border-b-2 transition-colors text-left",
              isActive ? "border-primary" : "border-transparent",
            ].join(" ")}>
            {tab.iconSrc && <img src={tab.iconSrc} alt="" className="size-6 shrink-0 object-cover" />}
            <span
              className={[
                "text-sm lg:text-lg leading-5 lg:leading-6 lg:whitespace-nowrap font-medium font-jost",
                isActive ? "text-primary" : "text-secondary",
              ].join(" ")}>
              {tab.label} ({tab.count})
            </span>
          </button>
        );
      })}
    </div>
  );
}
